<div>
  <!-- <div class="track-vehicle">
    <div class="card-top card-head">
      <h4>Track Vehicle</h4>
      <p>Select all required inputs</p>
    </div>
    <form [formGroup]="trackVehicleForm" (ngSubmit)="submitTrack()">
      <div class="form-row">
        <div class="form-item">
          <label>Vehicle Number*</label>
          <input type="text"  formControlName="vehicleNo" required>
          <div class="error" *ngIf="trackVehicleForm.get('vehicleNo')?.invalid && trackVehicleForm.get('vehicleNo')?.touched">
            <small *ngIf="trackVehicleForm.get('vehicleNo')?.errors?.['required']">Vehicle Number is required</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-item">
          <label>Select from Date*</label>
          <input type="date" formControlName="fromDate" required>
          <div class="error" *ngIf="trackVehicleForm.get('fromDate')?.invalid && trackVehicleForm.get('fromDate')?.touched">
            <small *ngIf="trackVehicleForm.get('fromDate')?.errors?.['required']">From Date is required</small>
          </div>
        </div>
        <div class="form-item">
          <label>Select to Date*</label>
          <input type="date" formControlName="toDate" required>
          <div class="error" *ngIf="trackVehicleForm.get('toDate')?.invalid && trackVehicleForm.get('toDate')?.touched">
            <small *ngIf="trackVehicleForm.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <button type="submit"
        class="btn-track btn-action"
        [disabled]="loadingservice.isLoading('track-vehicle')"
       >
        <fa-icon [icon]="['fas', 'magnifying-glass-plus']"></fa-icon>
         TRACK 
        <app-spinner 
        *ngIf="loadingservice.isLoading('track-vehicle')"
        size="normal"
        >        
        </app-spinner>
      </button>
    </form>
  </div> -->

<div class="vehicle-wrapper">
  <div class="top-header">
    <h3>Track Vehicle</h3>
    <p>Select all required inputs</p>
  </div>

  <div class="track-form">
    <form [formGroup]="trackVehicleForm" (ngSubmit)="submitTrack()">

      <div class="form-group" #vehicleWrapper>
        <label>Vehicle Number <small>*</small></label>
        <!-- <input type="text"  formControlName="vehicleNo" placeholder="Enter vehicle number" required> -->
          <!-- [(ngModel)]="searchText" -->

        <input type="text"
         formControlName="vehicleNo"
          id="vehicleNo"
          placeholder="Enter vehicle number"
          (input)="onSearch(trackVehicleForm.get('vehicleNo')?.value)"
          class="search-input"
          autocomplete="off"
          >
        <!-- <div *ngIf="suggestions && suggestions.length" class="suggestions-dropdown">
          <div *ngFor="let suggestion of suggestions"
              (click)="selectSuggestion(suggestion)"
              class="suggestion-item">
            <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon>
            <div class="suggestion-text">
              <span class="suggestion-main">{{ suggestion }}</span>
            </div>
          </div>
          <div *ngIf="suggestions.length === 0" class="no-suggestions">No results found</div>
        </div> -->
        <div class="suggestions-dropdown" >
          <ul *ngIf="suggestions && suggestions.length" class="suggestion-list">
            <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)">
              <!-- <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon> -->
              <span [innerHTML]="highlightMatch(suggestion)"></span>
            </li>
          </ul>
        </div>

        <div class="error" *ngIf="trackVehicleForm.get('vehicleNo')?.invalid && trackVehicleForm.get('vehicleNo')?.touched">
          <small *ngIf="trackVehicleForm.get('vehicleNo')?.errors?.['required']">Vehicle Number is required</small>
        </div>
      </div>

      <div class="date-form">
        <div class="form-group">
           <label for="fromDate">Select from Date <small>*</small></label>
          <!-- <input type="date" formControlName="fromDate" required> -->
          <!-- <p-datepicker formControlName="fromDate"
              iconDisplay="input"
              [showIcon]="true"
              iconDisplay="input" 
              inputId="buttondisplay" 
              [showButtonBar]="true" 
              [showOnFocus]="false"
              dateFormat="dd/mm/yy"
              /> -->
         
              <p-datepicker formControlName="fromDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="fromDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                            appendTo="body"
                            required
                            [baseZIndex]="1200"/>

          <div class="error" *ngIf="trackVehicleForm.get('fromDate')?.invalid && trackVehicleForm.get('fromDate')?.touched">
            <small *ngIf="trackVehicleForm.get('fromDate')?.errors?.['required']">From Date is required</small>
          </div>
        </div>
        <div class="form-group">
           <label for="toDate">Select to Date <small>*</small></label>
          <!-- <input type="date" formControlName="toDate" required> -->
            <p-datepicker formControlName="toDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="toDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                          appendTo="body"
                          required
                          [baseZIndex]="1200"/>
          <div class="error" *ngIf="trackVehicleForm.get('toDate')?.invalid && trackVehicleForm.get('toDate')?.touched">
            <small *ngIf="trackVehicleForm.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <div class="ctr-btn">
        <button type="submit" class="btn-track btn-action">
        <fa-icon [icon]="['fas', 'magnifying-glass-plus']"></fa-icon>
          TRACK 
        </button>
      </div>
    </form>
  </div>
</div>

  <div class="show-table-div" *ngIf="noRecords">
    <div class="error-msg">
        <p>
          <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
          No records found in the given input
        </p>
      </div>
  </div>

  <div class="show-table-div" *ngIf="showTable">
    <div class="top-header">
      <h3>Vehicle Activity</h3>
      <p>Vehicle Details As On {{trackVehicleForm.value.fromDate | reportingDate:'date'}} to
        {{trackVehicleForm.value.toDate | reportingDate:'date'}}</p>
    </div>
    <div class="table-container">
      <!-- <div class="card-top card-head">
        <h4>Vehicle Activity</h4>
        <p>Vehicle Details As On {{trackVehicleForm.value.fromDate}} to {{trackVehicleForm.value.toDate}}</p>
      </div> -->
        <app-shared-table-toolbar>
            <div toolbarSearch class="search-bar">
          <app-generic-search
              [apiUrl]="'track-vehicle/search_suggestion'"
              [resultsApiUrl]="'track-vehicle/'"
              [method]="'POST'"
              [searchParamName]="'search_text'"
              [extraBody]="{ camera_esn: camera_esn, 'vehicle_number': this.rawData.vehicle_number, 'from_date': this.rawData.from_date, 'to_date': this.rawData.to_date }"
              [pageSize]="10"
              [minChars]="2"
              (resultsFetched)="onResults($event)">
          </app-generic-search>
        </div>
            <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
          <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
          EXPORT EXCEL
        </button>
        </app-shared-table-toolbar>
      <div class="responsive-table-wrapper">
        <table>
          <thead class="table-name">
            <tr>
              <th>S.No</th>
                <th>Authorized</th>
              <th class="sortable-header" (click)="sortData('vehicle_number')">
                Vehicle Number
                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
              <th class="sortable-header" (click)="sortData('created_at')">
                  Date &amp; Time
                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
              <th class="sortable-header" (click)="sortData('direction')">
                Direction
                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
              <th class="sortable-header" (click)="sortData('camera_esn')">
                Camera
                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'camera_esn' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'camera_esn' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
                <th *ngFor="let column of vteColumns">{{ column.label }}</th>
              <th>Vehicle Image</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let record of vehicleData; let i = index">
               <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
              <td>
                <span [ngClass]="record.is_match ? 'green-circle' : 'red-circle'"></span>
              </td>
                <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                <td>{{ record.created_at | reportingDate }}</td>
              <td>
               {{ record.direction }}
              </td>
              <td>{{ displayCameraEsn(record) }}</td>
                <td *ngFor="let column of vteColumns">
                    <app-dynamic-column-host [column]="column" [row]="record"></app-dynamic-column-host>
                </td>
              <td>
                <button (click)="viewImage(record.vehicle_image_url, record.direction)">
                   <fa-icon [icon]="['fas', 'eye']" class="fa-light"></fa-icon>

                </button>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="footer">
          <div class="total-records">Total Records: {{ totalRecords }}</div>
            <app-vte-pagination
                    [currentPage]="currentPage"
                    [pageSize]="recordsPerPage"
                    [totalRecords]="totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
            </app-vte-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add this modal HTML below your table -->
 <app-image-viewer
  [images]="selectedImages"
  [show]="showModal"
  [closeModal]="closeModal"
 ></app-image-viewer>

<div *ngIf="showUnappliedFiltersDialog" class="confirmation-modal" role="dialog" aria-modal="true"
     aria-labelledby="unapplied-filters-title">
    <div class="modal-content">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon" aria-hidden="true"></i>
            <h3 id="unapplied-filters-title">Unapplied Filter Changes</h3>
        </div>
        <div class="modal-body">
            <p>
                You have modified the search filters but have not applied them yet.
            </p>
            <p>
                Please click <strong>Search</strong> to refresh the results before navigating between pages.
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="confirm-btn modal-green" (click)="applyUnappliedFilters()">
                Apply Filters
            </button>
            <button type="button" class="cancel-btn cancel-btn-green" (click)="cancelUnappliedFiltersDialog()">
                Cancel
            </button>
        </div>
    </div>
</div>
